module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_j_erythristic.742063f8.png";